import logging from 'node-logging-js';
import jsb from 'node-jsb';
import Masonry from 'masonry-layout';

class Projects {
    constructor(element, options) {
        logging.applyLogging(this, 'Projects');
        this.logDebug('options:', options);
        this.element = element;

        this.menuBtn = this.element.querySelector('.js-more');

        this.initializeEventListeners();
    }

    initializeEventListeners() {

        var msnry = new Masonry( '.project-list', {
            itemSelector: '.project-item',
            columnWidth: '.grid-sizer',
            percentPosition: true
        });

        this.menuBtn.addEventListener('click', () => {
            this.element.classList.add('is-expanded');
            this.menuBtn.classList.add('is-hidden');
            msnry.layout();
        });

    }
}

jsb.registerHandler('Projects', Projects);
export default Projects;
